export default "__VITE_ASSET__2tK1fkWA__"